import React, { Fragment } from "react";
import { Button, Grid, IconButton, Typography } from "@material-ui/core";
import RemoveIcon from "@material-ui/icons/Remove";
import AddIcon from "@material-ui/icons/Add";
import { Form, Formik, FieldArray } from "formik";
import {
  FTextField,
  FAutocomplete,
  FDatePicker,
  FFilePicker,
  FSwitch,
} from "../form-elements";
import LoadingComponent from "../loading";

export default function FormBuilder({
  submitTitle,
  schema,
  initialValues,
  handleSubmit,
  handleChange = (key, value) => {},
  form = [],
  actionComponent,
  submitDirty,
  formWrapper: FormWrapper = Fragment,
  formContainer: FormContainer = Fragment,
}) {
  const renderFormElement = (
    {
      _type,
      _wrapper: Wrapper,
      _itemsWrapper: ItemsWrapper = (props) => <Grid item xs {...props} />,
      _hidden,
      ...props
    },
    { values, ...args }
  ) => {
    if (_hidden) return null;
    const element = (() => {
      switch (_type) {
        case "textField":
          return <FTextField key={props.name}  onChange={e => handleChange(props.name, e)} {...props} />;
        case "autocomplete":
          return <FAutocomplete key={props.name}  onChange={e => handleChange(props.name, e)} {...props} />;
        case "filePicker":
          return <FFilePicker key={props.name} {...props} />;
        case "datePicker":
          return <FDatePicker key={props.name} {...props} />;
        case "switch":
          return <FSwitch key={props.name} {...props} />;
        case "array":
          return (
            <FieldArray
              key={props.name}
              name={props.name}
              render={(arrayHelpers) => {
                const items =
                  props.items instanceof Array
                    ? props.items
                    : props.items(arrayHelpers);
                return (
                  <>
                    <Grid container className="mt-2">
                      {props.label && (
                        <Grid item xs>
                          <Typography variant="h6">{props.label}</Typography>
                        </Grid>
                      )}
                      {!props.disableAdd && (
                        <Grid item>
                          <IconButton
                            size="small"
                            onClick={() => arrayHelpers.push(props.emptyValue)}
                          >
                            <AddIcon />
                          </IconButton>
                        </Grid>
                      )}
                    </Grid>
                    {values[props.name].map((property, index) => (
                      <Fragment key={index.toString()}>
                        <Grid
                          className={props.dense ? "" : "mb-4"}
                          container
                          alignItems="center"
                          spacing={2}
                        >
                          <ItemsWrapper>
                            {items.map((arg) => {
                              if (arg instanceof Function) arg = arg(index);
                              let { name, ...el } = arg;
                              name = `${props.name}[${index}].${name}`;
                              return renderFormElement(
                                { ...el, name },
                                { values, index, ...args }
                              );
                            })}
                          </ItemsWrapper>
                          {values[props.name].length >
                            (typeof props.minLength === "number"
                              ? props.minLength
                              : 1) && (
                            <Grid item>
                              <IconButton
                                size="small"
                                onClick={() => arrayHelpers.remove(index)}
                              >
                                <RemoveIcon />
                              </IconButton>
                            </Grid>
                          )}
                        </Grid>
                      </Fragment>
                    ))}
                  </>
                );
              }}
            />
          );
        case "customContent":
          return props.content({ values, ...args, props });
        case "container":
          return renderFormElements(props.form, { values, ...args });
        default:
          return null;
      }
    })();
    if (Wrapper) {
      return <Wrapper key={props.name}>{element}</Wrapper>;
    } else {
      return element;
    }
  };
  const renderFormElements = (form, args) => {
    const formArray = form instanceof Array ? form : form(args);
    return formArray.map((el) => renderFormElement(el, args));
  };
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validationSchema={schema}
      handleChange={(err) => console.log(err)}
    >
      {({ isSubmitting, ...args }) => (
        <LoadingComponent overlay isLoading={isSubmitting}>
          <Form>
            <FormContainer>
              <FormWrapper>
                {renderFormElements(form, { isSubmitting, ...args })}
              </FormWrapper>
              {actionComponent ? (
                actionComponent({ isSubmitting, ...args })
              ) : (
                <div className="text-center mt-2">
                  <Button
                    type="submit"
                    disabled={isSubmitting || (submitDirty && !args.dirty)}
                    variant="contained"
                    color="primary"
                  >
                    {submitTitle || "ذخیره"}
                  </Button>
                </div>
              )}
            </FormContainer>
          </Form>
        </LoadingComponent>
      )}
    </Formik>
  );
}
